const GET_URL = 'url';
const GET_ID = 'id';
const GET_ACTIVE = 'active';
/**
 * Creates the model if there are query params in the url. Else returns default model from constants.
 */
export const createInitialModel = (categories, images) => {
    // get query params if present.
    let params = (new URL(document.location)).searchParams

    if (params.toString() == '') {
        return categories;
    }

    let allParams = [];
    const paramsCallback = (value, key) => {
        allParams.push({ key, value });
    }
    params.forEach(paramsCallback);

    let newCategories = [];
    allParams.forEach(param => {
        let iterate = newCategories.length > 0 ? newCategories : categories;
        newCategories = iterate.map(cat => {
            if (hasSubcategories(cat)) {
                return {
                    ...cat,
                    subCategories: cat.subCategories.map(subCat => {
                        if (simplifyCategoryName(subCat.category).toLowerCase() == param.key.toLowerCase()) {
                            return {
                                ...subCat,
                                selectedImage: param.value,
                                imageUrl: getImageData(images, subCat.category, param.value, GET_URL, true),
                                imageId: getImageData(images, subCat.category, param.value, GET_ID, true),
                                active: getImageData(images, subCat.category, param.value, GET_ACTIVE, true)
                            }
                        } else {
                            return subCat;
                        }
                    })
                }
            } else {
                if (simplifyCategoryName(cat.category).toLowerCase() == param.key.toLowerCase()) {
                    return {
                        ...cat,
                        selectedImage: parseInt(param.value),
                        imageUrl: getImageData(images, cat.category, param.value, GET_URL),
                        imageId: getImageData(images, cat.category, param.value, GET_ID),
                        active: getImageData(images, cat.category, param.value, GET_ACTIVE)
                    }   
                } else {
                    return cat;
                }
            }
        });
    });

    return newCategories;
}

const hasSubcategories = (category) => {
    return category.subCategories.length > 0;
}

/**
 * Returns the image url
 * @param {the images array} images 
 * @param {the name of the current category} category 
 * @param {the index of the image to be selectedImage} index 
 */
const getImageData = (images, category, index, type, isSubCategory = false) => {
    let trimmedImages = images.filter(img => img.category.toLowerCase() === category.toLowerCase());
    let imageIndex = 0;
    if (!isSubCategory) {
        imageIndex = index;
    } else {
        try {
            imageIndex = parseInt(index.split('-')[1])
        } catch (error){
            imageIndex = 0;
        }
    }
    let data = '';
    switch(type) {
        case GET_URL:
            data = trimmedImages[imageIndex] ? trimmedImages[imageIndex].ImageUrl : '';
            break;
        case GET_ID:
            data = trimmedImages[imageIndex] ? trimmedImages[imageIndex].ImageId : '';
            break;
        case GET_ACTIVE:
            data = trimmedImages[imageIndex] ? trimmedImages[imageIndex].Active : false
    }

    return data;
}

export const simplifyCategoryName = (categoryName) => {
    const removeSpacesAndSpecialCharsPattern = /[^A-Z0-9]/ig;
    return categoryName.replace(removeSpacesAndSpecialCharsPattern, '');
}

/**
 * Checks the model for layers marked as inactive from nop backoffice
 * @param selectedImages 
 */
export const hasInactiveLayers = selectedImages => {
    let inactive = false;
    selectedImages.forEach(category => {
        if (category.subCategories.length === 0) {
            if (category.active !== null && category.active === false) {
                inactive = true;
            }

        } else {
            category.subCategories.forEach(subcategory => {
                if (subcategory.active !== null && subcategory.active === false) {
                    inactive = true;
                }
            })
        }
    });
    return inactive;
}

export const getInactiveLayerNamesFromModel = selectedImages => {
    let inactive = [];
    selectedImages.forEach(category => {
        if (category.subCategories.length === 0) {
            if (category.active !== null && category.active === false) {
                inactive.push(category.category);
            }

        } else {
            category.subCategories.forEach(subcategory => {
                if (subcategory.active !== null && subcategory.active === false) {
                    inactive.push(`${category.category} > ${subcategory.category}`);
                }
            })
        }
    });
    return inactive;
}
